export default "__VITE_ASSET__fba41072__"